import {profileSalaryDetailsAdd} from '../../../segment'

const lawyerSalaryController = ($scope, $rootScope, logger, SalaryApi) => {
  const getSymbolFromCurrency = require('currency-symbol-map')
  const currencyToSymbolMap = require('currency-symbol-map/map')

  $scope.salaryCurrencySymbol = getSymbolFromCurrency('GBP')
  $scope.bonusCurrencySymbol = getSymbolFromCurrency('GBP')

  $scope.notify = (type, message) => {
    logger.notify(type, message)
  }

  $scope.initializeSalary = async () => {
    try {
      const {data: salaryData} = await SalaryApi.getCandidateSalary(
        $scope.candidate.id
      )
      $scope.candidate.salary = populateSalaryDetails(salaryData)
      // eslint-disable-next-line unicorn/prefer-optional-catch-binding
    } catch (error) {}
  }

  $scope.initializeSalary()

  $scope.salaryDetails = {
    unit: '',
    amount: '',
    salaryDate: '',
    salaryDateToShow: '',
    bonusUnit: '',
    bonusAmount: '',
    bonusDate: '',
    bonusDateToShow: '',
  }
  $scope.salaryDetailsDatePickerOptions = {
    'datepicker-mode': "'day'",
    'year-format': "'yy'",
    'starting-day': 1,
    defaultDate: '1',
  }
  $scope.currencyList = Object.keys(currencyToSymbolMap)

  let sorting = {
    GBP: 'GBP',
    USD: 'USD',
    EUR: 'EUR',
    JPY: 'JPY',
    CHF: 'CHF',
    AUD: 'AUD',
    CAD: 'CAD',
    CNY: 'CNY',
    NZD: 'NZD',
    INR: 'INR',
    SEK: 'SEK',
    ZAR: 'ZAR',
    HKD: 'HKD',
  }
  let result = []

  $scope.updateSalarySymbol = code => {
    $scope.salaryCurrencySymbol = getSymbolFromCurrency(code)
  }

  $scope.updateBonusSymbol = code => {
    $scope.bonusCurrencySymbol = getSymbolFromCurrency(code)
  }

  $scope.currencyList = $scope.currencyList.filter(current => {
    // eslint-disable-next-line no-prototype-builtins
    return !sorting.hasOwnProperty(current)
  })

  result.push(Object.values(sorting))
  result.push($scope.currencyList)

  $scope.currencyList = result.flatten()

  $scope.lockedSalary = {isSelected: false}
  $scope.lockUnlockSalary = () => {
    $scope.lockedSalary.isSelected = !$scope.lockedSalary.isSelected
    $scope.showHistory = false
    $scope.addingSalaryDetails = false
    $scope.editingSalaryDetails = false
  }

  let populateSalaryDetails = candidateSalary => {
    $scope.salaryDetails = candidateSalary[0]
    $scope.salaryDetails.salaryAmountToShow =
      $scope.salaryDetails.amount &&
      $scope.salaryDetails.amount
        .toString()
        .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
    $scope.salaryDetails.bonusAmountToShow = $scope.salaryDetails.bonusAmount
      ? $scope.salaryDetails.bonusAmount
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
      : undefined
    $scope.salaryDetails.salaryDateToShow =
      $scope.salaryDetails.salaryDate &&
      moment($scope.salaryDetails.salaryDate)
        .local()
        .format('DD MMM YYYY')
    $scope.salaryDetails.bonusDateToShow =
      $scope.salaryDetails.bonusDate &&
      moment($scope.salaryDetails.bonusDate)
        .local()
        .format('DD MMM YYYY')
  }

  $scope.fetchSalaryHistory = async () => {
    $scope.addingSalaryDetails = false
    $scope.editingSalaryDetails = false
    if ($scope.showHistory === false) {
      SalaryApi.getCandidateSalary($scope.candidate.id, false)
        .then(salaryHistory => {
          if (salaryHistory.data.length > 1) {
            $scope.salaryHistory = salaryHistory.data
            $scope.salaryHistory.forEach(salary => {
              salary.salaryDateToShow =
                salary.salaryDate &&
                moment(salary.salaryDate)
                  .local()
                  .format('DD MMM YYYY')
              salary.bonusDateToShow =
                salary.bonusDate &&
                moment(salary.bonusDate)
                  .local()
                  .format('DD MMM YYYY')
              salary.salaryAmountToShow =
                salary.amount &&
                salary.amount
                  .toString()
                  .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
              salary.bonusAmountToShow = salary.bonusAmount
                ? salary.bonusAmount
                    .toString()
                    .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
                : undefined
            })
            $scope.showHistory = true
            $scope.$apply()
          } else {
            $scope.notify('warning', 'No salary history found.')
          }
        })
        .catch($rootScope.errorHandler)
    } else {
      $scope.showHistory = false
    }
  }

  $scope.AddSalaryDetails = () => {
    if ($scope.candidate.employer) {
      $scope.editableSalary = {
        unit: 'GBP',
        amount: undefined,
        payPeriod: 'per year',
        locationId: $scope.candidate.location.id,
        employerId: $scope.candidate.employer.id,
        salaryDate: undefined,
        bonusUnit: 'GBP',
        bonusAmount: undefined,
        bonusDate: undefined,
      }
      $scope.addingSalaryDetails = true
      $scope.showHistory = false
    } else {
      $scope.notify('error', "Please add 'Current Experience' to add salary.")
    }
  }

  $scope.editSalaryDetails = () => {
    $scope.editableSalary = $scope.salaryDetails
    $scope.editingSalaryDetails = true
  }

  $scope.editHistorySalaryDetails = (salary, index) => {
    $scope.salaryHistoryIndex = index
    $scope.editableSalary = salary
    $scope.editingSalaryDetails = true
  }

  $scope.trackSalary = (salary, eventName) => {
    profileSalaryDetailsAdd({
      salary: `${salary.unit} ${salary.amount} per ${salary.salaryPayPeriod}`,
      salaryDate: salary.salaryDateToShow,
      bonus: salary.bonusAmount
        ? `${salary.bonusUnit} ${salary.bonusAmount}`
        : '',
      bonusDate: salary.bonusDate ? salary.bonusDateToShow : '',
      employerId: salary.firmID,
      employerName: salary.firmName,
      candidateId: salary.lawyerID,
      location: salary.location,
      action: eventName,
    })
  }

  // eslint-disable-next-line complexity
  $scope.saveSalaryDetails = async () => {
    let editError = false
    let isBonusEdited = false
    let isBonusEmpty = false
    let bonusEditError = false

    if (!$scope.editableSalary.unit || _.isEmpty($scope.editableSalary.unit)) {
      $scope.notify(
        'error',
        'Please provide your current salary currency code.'
      )
      editError = true
    } else if (
      !$scope.editableSalary.amount ||
      $scope.editableSalary.amount === ''
    ) {
      $scope.notify('error', 'Please provide your current salary.')
      editError = true
    } else if (
      !$scope.editableSalary.salaryDate ||
      $scope.editableSalary.salaryDate === ''
    ) {
      $scope.notify('error', 'Please provide your current salary date.')
      editError = true
    } else if (
      $scope.editableSalary.amount &&
      !$scope.editableSalary.payPeriod
    ) {
      $scope.notify('error', 'Please provide Salary Pay Period.')
      editError = true
    }

    if (
      !$scope.editableSalary.bonusAmount ||
      $scope.editableSalary.bonusAmount === '' ||
      $scope.editableSalary.bonusAmount === 0
    ) {
      $scope.editableSalary.bonusAmount = undefined
      isBonusEmpty = true
    } else {
      isBonusEdited = true
    }

    if ($scope.editableSalary.bonusDate || $scope.editableSalary.bonusUnit) {
      bonusEditError = true
    }

    if (
      isBonusEdited &&
      (!$scope.editableSalary.bonusDate ||
        $scope.editableSalary.bonusDate === '' ||
        !$scope.editableSalary.bonusUnit ||
        _.isEmpty($scope.editableSalary.bonusUnit))
    ) {
      editError = true
      $scope.notify('error', 'Please provide last bonus complete details.')
    } else if (!editError && bonusEditError && isBonusEmpty) {
      $scope.editableSalary.bonusDate = undefined
      $scope.editableSalary.bonusUnit = undefined
      $scope.editableSalary.bonusAmount = undefined
    }

    if (!editError) {
      $scope.editableSalary.salaryDateToShow =
        $scope.editableSalary.salaryDate &&
        moment($scope.editableSalary.salaryDate)
          .local()
          .format('DD MMM YYYY')
      $scope.editableSalary.bonusDateToShow =
        $scope.editableSalary.bonusDate &&
        moment($scope.editableSalary.bonusDate)
          .local()
          .format('DD MMM YYYY')
      $scope.editableSalary.salaryAmountToShow =
        $scope.editableSalary.amount &&
        $scope.editableSalary.amount
          .toString()
          .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
      $scope.editableSalary.bonusAmountToShow = $scope.editableSalary
        .bonusAmount
        ? $scope.editableSalary.bonusAmount
            .toString()
            .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,')
        : undefined
      $scope.editingeditableSalary = false

      const salaryPayload = {
        unit: $scope.editableSalary.unit,
        amount: $scope.editableSalary.amount,
        payPeriod: $scope.editableSalary.payPeriod,
        locationId: $scope.editableSalary.locationId,
        employerId: $scope.editableSalary.employerId,
        salaryDate: moment($scope.editableSalary.salaryDate).format(
          'YYYY-MM-DD'
        ),
        bonusUnit: $scope.editableSalary.bonusUnit,
        bonusAmount: $scope.editableSalary.bonusAmount,
        bonusDate: moment($scope.editableSalary.bonusDate).format('YYYY-MM-DD'),
      }
      if ($scope.addingSalaryDetails) {
        const {data: addSalaryResponse} = await SalaryApi.addCandidateSalary(
          $scope.candidate.id,
          salaryPayload
        )
        $scope.salaryDetails = $scope.editableSalary
        $scope.salaryDetails.id = addSalaryResponse.id
        $scope.salaryDetails.location = {name: $scope.candidate.location.name}
        $scope.salaryDetails.employer = {name: $scope.candidate.employer.name}
        $scope.addingSalaryDetails = false
        $scope.notify('success', 'Successfully updated')
        $scope.trackSalary($scope.salaryDetails, 'Add')
        $scope.$apply()
      } else if ($scope.editingSalaryDetails) {
        delete salaryPayload.locationId
        delete salaryPayload.employerId
        SalaryApi.updateCandidateSalary($scope.editableSalary.id, salaryPayload)
          .then(_data => {
            if ($scope.showHistory) {
              $scope.salaryHistory[$scope.salaryHistoryIndex] =
                $scope.editableSalary
              if ($scope.salaryHistoryIndex === 0) {
                $scope.salaryDetails = $scope.editableSalary
              }
            } else {
              $scope.salaryDetails = $scope.editableSalary
            }

            $scope.trackSalary($scope.salaryDetails, 'Edit')
            $scope.editingSalaryDetails = false
            $scope.$apply()
          })
          .catch(_error => $scope.notify('error', 'Error updating salary.'))
      }
    }
  }

  $scope.cancelSalaryDetails = () => {
    if (!$scope.editableSalary.bonusAmountToShow) {
      $scope.editableSalary.bonusDate = undefined
      $scope.editableSalary.bonusUnit = undefined
    }

    $scope.editingSalaryDetails = false
    $scope.addingSalaryDetails = false
  }
}

export {lawyerSalaryController}



// WEBPACK FOOTER //
// ./scripts/shared/directives/lawyer-salary/controller.js